
import OAuthService from "services/oauth-service";

// Define the scopes required for YouTube
const SCOPES = "https://www.googleapis.com/auth/youtube.readonly";

export const youtubeLoginHandler = async (resolve, reject) => {
  try {
    // Use the new OAuth service to initiate login
    console.log("Initiating Google login...");
    OAuthService.initiateOAuthLogin("google");
    resolve(); // Resolve immediately after the redirect is initiated
  } catch (error) {
    console.error("Error during Google login:", error.message);
    reject(error); // Reject the promise if there is an error
  }
};
